import { ClickAwayListener, styled } from "@mui/material";
import * as React from "react";
import Button from "./Button";
import { ErrorList } from "./ErrorList";
import { ErrorTooltip } from "./ErrorTooltip";

import { GroupedNavigationContext } from "./GroupedNavigationContext";
import { TableChildProps } from "./Table";

interface Props {
  errors: string[];
  propagated: TableChildProps;
  rowKey: string;
}

interface State {
  open: boolean;
}

const BadgeButton = styled(Button)({
  pointerEvents: "auto",
});

export class RowErrorBadge extends React.PureComponent<Props, State> {
  static contextType = GroupedNavigationContext;
  private buttonRef = React.createRef<HTMLButtonElement>();

  public constructor(props: Props) {
    super(props);

    this.state = { open: false };

    if (!props.propagated.parentTable.isVerticalLayout) {
      props.propagated.parentTable
        .getTable()
        .rowErrorBadges.set(props.rowKey, this);
    }
  }

  public close = () => {
    this.setState({ open: false });
  };

  public open = () => {
    this.setState({ open: true });
  };

  public render() {
    const { groupControlsFocus } = this.context;
    if (!this.props.errors) {
      return null;
    }

    const inTable = !this.props.propagated.parentTable.isVerticalLayout;

    const onButtonClick = () => {
      // Fix for Safari not opening tooltip
      this.buttonRef.current!.focus();
      this.setState({ open: true });
    };

    return (
      <ClickAwayListener
        mouseEvent="onMouseDown"
        onClickAway={() => this.setState({ open: false })}
      >
        <ErrorTooltip
          // DisableHoverListener
          enterTouchDelay={0}
          open={this.state.open}
          title={<ErrorList errors={this.props.errors} />}
        >
          {inTable ? (
            <BadgeButton
              aria-hidden={true}
              color="danger"
              customSize="tiny"
              icon="fas fa-exclamation"
              onClick={onButtonClick}
              ref={this.buttonRef}
              sx={{
                marginBottom: "8px",
                marginLeft: "0px",
                marginRight: "8px",
                marginTop: "0px",
              }}
              tabIndex={-1}
            />
          ) : (
            <BadgeButton
              aria-label="Row error"
              color="danger"
              size="small"
              icon="fas fa-exclamation"
              onClick={onButtonClick}
              ref={this.buttonRef}
              tabIndex={groupControlsFocus ? -1 : undefined}
            />
          )}
        </ErrorTooltip>
      </ClickAwayListener>
    );
  }
}
